import { safeJsonParse } from "./json-parser";
import { logger } from "./logger";

export const setSessionStorageItem = (key: string, value: string): void => {
  if (typeof window === "undefined" || !value || !key) {
    return;
  }

  try {
    sessionStorage.setItem(key, value);
  } catch (error) {
    logger({
      message: "Error setting sessionStorage item",
      error: error as Error,
    });
  }
};

export const getSessionStorageItem = (key: string): string | null => {
  if (typeof window === "undefined" || !key) {
    return null;
  }

  try {
    return sessionStorage.getItem(key);
  } catch (error) {
    logger({
      message: "Error getting sessionStorage item",
      error: error as Error,
    });
    return null;
  }
};

export const setSessionStorageJSON = <T>(key: string, value: T): void => {
  if (typeof window === "undefined" || !value || !key) {
    return;
  }

  try {
    const valueString = JSON.stringify(value);
    sessionStorage.setItem(key, valueString);
  } catch (error) {
    logger({
      message: "Error setting sessionStorage item",
      error: error as Error,
    });
  }
};

export const getSessionStorageJSON = <T>(key: string): T | null => {
  if (typeof window === "undefined" || !key) {
    return null;
  }

  const storageValue = sessionStorage.getItem(key);

  return storageValue ? safeJsonParse<T>(storageValue) : null;
};

export const deleteSessionStorageItem = (key: string): void => {
  if (typeof window === "undefined" || !key) {
    return;
  }

  try {
    sessionStorage.removeItem(key);
  } catch (error) {
    logger({
      message: "Error removing sessionStorage item",
      error: error as Error,
    });
  }
};
